module.exports = __webpack_public_path__ + "static/media/plage.d66878e6.jpg";